module.exports = __webpack_public_path__ + "img/phone.324491de.svg";